<template>
  <v-row class="py-3">
    <v-col class="d-flex align-center" cols="12" md="6">
      <div class="d-flex flex-column">
        <!-- <v-card-subtitle v-if="wip" class="title py-0 px-0 grey--text">
          {{ title
          }}</v-card-subtitle>
        <v-card-subtitle v-else class="title py-0 px-0">
          {{ title
          }}</v-card-subtitle>
        <h5 class="grey--text">{{ subtitle }}</h5> -->
      </div>
    </v-col>
    <v-col class="d-flex align-center justify-end" cols="12" md="6">
      <div class="d-flex align-center">
        <v-btn @click="openEditor = true" color="primary">
          <v-icon>mdi-pencil-outline</v-icon> {{ $t('common.open') }}
        </v-btn>
        <v-dialog v-model="openEditor" max-width="980">
          <v-card class="mx-auto">
            <v-card-title>{{ title }}</v-card-title>
            <v-card-subtitle>{{ label }}</v-card-subtitle>
            <v-card-text v-if="!loading && openEditor">
              
              <editor
       api-key="zgjv6fbwf0mja43cycbmvhureia0qtjihu7h2v2ps3gxod22"
       v-model="value"
       :init="{
         height: 500,
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ]
       }"
     />


              <!-- <vue2-tinymce-editor :id="id" v-model="value"></vue2-tinymce-editor> -->


              <!-- <v-tiptap v-model="value" label="" :toolbar="toolbar" :injectCSS="true"></v-tiptap> -->
              <div class="d-flex pt-3">
                <v-spacer></v-spacer>
                <v-btn text @click="cancel()">{{ $t('common.cancel') }}</v-btn>
                <v-btn color="success" class="ml-1" elevation="0" @click="saveChanges()">{{ $t('common.save') }}</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>


      </div>

    </v-col>
  </v-row>
</template>

<script>
import {
  getFirestore,
  collection,
  query,
  deleteDoc,
  setDoc,
  doc,
  getDoc,
  getDocs,
  writeBatch,
} from "firebase/firestore";
import { mapActions } from "vuex";
// import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import Editor from '@tinymce/tinymce-vue'


import config from "@/store/config";
import moment from 'moment'
import { initializeApp } from "firebase/app";
export default {
  name: "textEditor",
  components: {
    // Vue2TinymceEditor
    Editor
  },
  props: {
    reference: {
      type: String,
      required: true,
    },
    title: {
      type: String,

    },
    subtitle: {
      type: String,
    },
    label: {
      type: String
    }

  },
  data() {
    return {
      loading: true,
      id: null,
      openEditor: false,
      toolbar: ["bold",
        "italic",
        "underline",
        "color",
        "|",
        "headings",
        "|",
        "left",
        "center",
        "right",
        "justify",
        "|",
        "bulletList",
        "orderedList",
        "|",
        "link",
        "emoji",
        "|",

        "#calendar",
        "#timer",
        "#groupicon",
        "|",
        "clear"],
      readOnly: true,
      value: null,
      snap: null
    };
  },
  created(){
    this.loading = true
    this.id = `ID-${moment('X')}`
  },
  mounted() {
    const firebase = initializeApp(config);
      const db = getFirestore(firebase);
    // get ID
    const docRef = doc(db, "companyText", this.reference);
    getDoc(docRef).then((document) => {
      if (document.exists()) {
        this.snap = document.data()
        const snap = JSON.parse(JSON.stringify(this.snap))
        this.value = snap.text
      }
      this.loading = false
    })


  },
  computed: {

    invertSnap: {
      get() {
        return this.reverseValue == true ? !this.localSnap : this.localSnap
      },
      set(value) {
        if (this.reverseValue == true) {
          this.localSnap = !value;
        } else {
          this.localSnap = value;
        }

      }
    },

    allowText() {
      return this.activeText ? this.activeText : this.$t('mainStore.editor.allow')
    },
    disallowText() {
      return this.inactiveText ? this.inactiveText : this.$t('mainStore.editor.disallow')
    }
  },
  watch: {
   
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),

    cancel() {
      let v = JSON.parse(JSON.stringify(this.snap))
      this.value = v.text
      this.openEditor =false
    },
    saveChanges() {
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const Form = {
        date: moment().format(),
        text: this.value
      }
      console.log("Form", Form);
      Form.createdOn = moment().format();
      setDoc(doc(db, "companyText", this.reference), Form)
        .then(() => {
          this.processing = false;
        })
        .then(() => {
          this.showSnack({
            text: '¡Texto actualizado exitosamente!',
            color: "success",
            timeout: 3800,
            icon: "mdi-check",
          });

          this.openEditor = false;
        });
    },
    cancelChanges() {
    },
  },
};
</script>

<style lang="scss" scoped></style>
